exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".land {\n    stroke: #ddd;\n    stroke-opacity: 1;\n    stroke-width: 0.5;\n}\n\n.hidden-path {\n    display: none;\n}", ""]);

// exports
